/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1LocationCountriesId202,
  DeleteApiV1LocationCountriesId401,
  DeleteApiV1LocationCountriesId404,
  DeleteApiV1LocationCountriesId500,
  DeleteApiV1LocationCountriesIdMutationResponse,
  DeleteApiV1LocationCountriesIdPathParams,
} from "../../types/locationCountryController/DeleteApiV1LocationCountriesId.ts";

export const deleteApiV1LocationCountriesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1LocationCountriesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1LocationCountriesId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationCountriesId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1LocationCountriesId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationCountriesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1LocationCountriesId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationCountriesId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1LocationCountriesId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationCountriesId500>;

export const deleteApiV1LocationCountriesIdMutationResponseSchema = z.lazy(
  () => deleteApiV1LocationCountriesId202Schema,
) as unknown as ToZod<DeleteApiV1LocationCountriesIdMutationResponse>;
